import React from 'react';
import withStyles from 'isomorphic-style-loader/withStyles';
import { useForm } from 'react-hook-form';
import { items, getEquivalents } from './data';
import SelectNative from '../../atoms/SelectNative/SelectNative';
import s from './VEFSCalculator.css';

const formatNumber = (num, noDigits = 2) =>
  num.toLocaleString('sv-SE', {
    maximumSignificantDigits: noDigits,
    minimumSignificantDigits: noDigits,
    maximumFractionDigits: num > 1e6 ? 1 : 0,
    minimumFractionDigits: 0,
    roundingPriority: 'lessPrecision',
    notation: num > 1e6 ? 'compact' : 'standard',
    compactDisplay: 'long',
  });

const NumberDisplay = ({ header, value }) => (
  <div className={s.numberDisplay}>
    <span>{header}</span>
    <span>{value}</span>
  </div>
);

const VEFSCalculator = () => {
  const { register, watch } = useForm();
  const activeItem = watch('item', items[0]);
  const equivalents = getEquivalents(activeItem);

  return (
    <div className={s.vefsCalculator}>
      <SelectNative name="item" label="Välj roll" register={register()} defaultValue={items[0]}>
        {items.map(item => (
          <option value={item}>{item}</option>
        ))}
      </SelectNative>
      <div className={s.numbers}>
        <NumberDisplay
          header="Vid 2,5% tillväxt"
          value={`${formatNumber(equivalents.SN)} ${equivalents.unit}`}
        />
        <NumberDisplay
          header="Vid 1,8% tillväxt"
          value={`${formatNumber(equivalents.KI)} ${equivalents.unit}`}
        />
        <NumberDisplay header="Skillnad" value={`${formatNumber(equivalents.delta)} ${equivalents.unit}`} />
      </div>
    </div>
  );
};

export default withStyles(s)(VEFSCalculator);
